import styled from "styled-components";
import { BodyDefault, BodyMedium, HeadLine1, HeadLine2, HeadLine3 } from "../../../components/typography/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 10px 20px;
  box-sizing: border-box;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const PageTitle = styled(HeadLine1)`
  color: ${({ theme }) => theme.palette[850]};
`;

export const FiltersCard = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(170px, 1fr));
  gap: 12px;
  align-items: end;
  width: 100%;
  background-color: ${({ theme }) => theme.palette[10]};
  border: ${({ theme }) => `1px solid ${theme.palette[20]}`};
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  padding: 16px 20px;
  box-sizing: border-box;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CardTitle = styled(BodyDefault)`
  color: ${({ theme }) => theme.grey[700]};
`;

export const CardValue = styled(HeadLine2)`
  color: ${({ theme }) => theme.palette[900]};
`;

export const CardMeta = styled(BodyDefault)`
  color: ${({ theme }) => theme.grey[700]};
`;

export const SectionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette[10]};
  border: ${({ theme }) => `1px solid ${theme.palette[20]}`};
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  padding: 16px 20px;
  box-sizing: border-box;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SectionTitle = styled(HeadLine3)`
  color: ${({ theme }) => theme.palette[850]};
`;

export const SectionSubtitle = styled(BodyDefault)`
  color: ${({ theme }) => theme.grey[700]};
`;

export const CellStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CellPrimary = styled(BodyDefault)`
  color: ${({ theme }) => theme.palette[900]};
`;

export const CellSecondary = styled(BodyDefault)`
  color: ${({ theme }) => theme.grey[700]};
`;

export const CellLink = styled(BodyMedium)`
  color: ${({ theme }) => theme.primary[600]};
  cursor: pointer;
`;

export const EmptyText = styled(BodyDefault)`
  color: ${({ theme }) => theme.grey[700]};
`;
